import styled from 'styled-components'
import Navbar from 'react-bootstrap/Navbar'

export const StyledNavbar = styled(Navbar)`
  padding: 0;
`
